export const es = {
  welcome: 'bienvenido',
  trading_accounts: 'cuentas de operaciones',
  logout: 'cerrar sesión',
  account_list: 'lista de cuentas',
  create_live_account: 'crear una cuenta real',
  upgrade_to_live_account: 'mejorar a una cuenta real',
  create_demo_account: 'crear una cuenta de prueba',
  finance: 'finanzas',
  deposit_funds: 'depositar fondos',
  withdraw_funds: 'retirar fondos',
  internal_transfer: 'transferencia interna',
  external_transfer: 'transferencia externa',
  transfer_back: 'transferir de vuelta',
  transfer_back_to_my_local_depositor: 'transferir de vuelta a mi depositante local',
  transfer_to_external_account: 'transferir a una cuenta externa',
  payment_history: 'historial de pagos',
  my_cards: 'mis tarjetas',
  my_profile: 'mi perfil',
  personal_information: 'información personal',
  change_password: 'cambiar la contraseña',
  upload_documents: 'cargar documentos',
  partner: 'socio',
  overview: 'resumen',
  clients: 'clientes',
  sub_ibs: 'sub ibs',
  payout: 'pago',
  marketing_material: 'material de marketing',
  withdrawal_history: 'historial de retiradas',
  become_a_partner: 'convertirse en socio',
  please_fill_the_following_fields: 'complete los siguientes campos',
  what_geographic_region: '¿A qué región geográfica se dirigirá principalmente?',
  submit: 'enviar',
  upload_documents_notice: 'Para aprobar su cuenta y poder operar, <a>cargue sus documentos</a> y complete su perfil',
  change_password_ta_notice: 'Toda nueva cuenta de operaciones utilizará su nueva contraseña. Esto no afecta a sus cuentas de operaciones actuales.',
  changepass_error: 'La contraseña actual es incorrecta; inténtelo de nuevo.',
  changepass_success: 'Contraseña cambiada correctamente',
  current_password: 'contraseña actual',
  new_password: 'contraseña nueva',
  confirm_new_password: 'confirmar nueva contraseña',
  pending_account: 'cuenta pendiente',
  account_must_be_approved_message: 'Su cuenta debe aprobarse antes de crear una nueva cuenta de operaciones real.',
  new_trading_account_message: 'Nueva cuenta de operaciones creada con éxito',
  password_generated_for_ta: 'Se generó una contraseña y se envió a su correo electrónico para que pueda usar su nueva cuenta de operaciones',
  new_trading_account_type_message: 'Nueva cuenta de operaciones de {type} creada correctamente',
  choose_your_desired_trading_platform_and_settings: 'Elija la plataforma de operaciones y la configuración que desee',
  select_leverage: 'seleccione el apalancamiento',
  create: 'crear',
  select_account_type: 'seleccione el tipo de cuenta',
  select_currency: 'seleccione divisa',
  no_trading_account_found: 'No se ha encontrado ninguna cuenta de operaciones.',
  bankwire_notice:
    'Gracias por enviarnos sus datos bancarios Registraremos sus datos en nuestro banco.<br><br> Recibirá los datos de la transferencia por correo electrónico en un plazo de 24 horas junto con su referencia de pago personal. Puede utilizar estos datos para futuros depósitos.<br><br><strong>IMPORTANTE:</strong> La referencia de pago está personalizada para un cliente. Si no utiliza la referencia de pago que recibe, no podremos aceptar su depósito. Ningún tercero puede utilizar la misma referencia de pago.',
  deposit: 'depositar',
  account_details: 'datos de la cuenta',
  enter_fasapay_id: 'Introduzca su ID de cuenta de Fasapay:',
  account_id: 'ID de cuenta',
  secure_id: 'ID seguro',
  continue: 'continuar',
  bankwire_details_notice:
    'Nuestro banco requiere sus datos bancarios para procesar su depósito. Todos los depósitos realizados mediante transferencia bancaria se devolverán a la misma cuenta desde la que realizó el depósito.',
  bankwire_deposit_details_notice:
    'Nuestro banco requiere sus datos bancarios para procesar su depósito. Todos los depósitos realizados mediante transferencia bancaria se devolverán a la misma cuenta desde la que realizó el depósito.',
  bankwire_withdrawal_details_notice:
    'Nuestro banco necesita sus datos bancarios para procesar su retirada. Todas las retiradas realizadas mediante transferencia bancaria se devolverán a la misma cuenta desde la que realizó el depósito.',
  bankwire_verify_account_notice:
    '<p>Debe verificar su cuenta antes de utilizar la transferencia bancaria. Por favor, <a href="{FSROOT_URL}upload-documents">cargue sus documentos</a></p>',
  bankwire_amount_label: 'Importe (depósito mínimo de {minDeposit})',
  bank_name: 'nombre del banco',
  full_name: 'nombre completo',
  deposit_methods: 'métodos de depósito',
  deposit_select_ta_p: 'Seleccione la cuenta de operaciones en la que desea depositar fondos:',
  coming_soon: 'próximamente',
  amount: 'importe',
  proof_of_id: 'Prueba de identidad',
  proof_of_id_instructions: 'Prueba de identidad',
  documents_must_contain_all_of_the_following_details: 'Los documentos deben cumplir los siguientes requisitos:',
  your_full_name: 'Su nombre completo',
  a_unique_id_number: 'Un número de identificación único',
  your_birthdate: 'Su fecha de nacimiento',
  your_place_of_birth: 'Su lugar de nacimiento',
  a_visible_photo: 'Una foto visible',
  your_signature: 'Su firma',
  your_nationality: 'Su nacionalidad',
  proof_of_residence_instructions: 'Cargue su factura de servicios públicos o su extracto bancario.',
  your_residential_address: 'Su dirección de residencia',
  date_of_issue: 'Fecha de expedición',
  other: 'otros',
  other_documents_instructions: 'Otros documentos que hayan sido solicitados por nuestro departamento de verificación.',
  deposit_failed: 'depósito fallido',
  deposit_successful: 'depósito realizado correctamente',
  already_logged_in: 'ya ha iniciado sesión',
  login: 'iniciar sesión',
  create_an_account: 'crear una cuenta',
  partner_clients: 'Socio - Clientes',
  trades: 'operaciones',
  client_id: 'ID de cliente',
  trading_account: 'cuenta de operaciones',
  platform: 'plataforma',
  order: 'orden',
  pair: 'par',
  volume: 'volumen',
  close_date: 'fecha de cierre',
  commission: 'comisión',
  status: 'estado',
  total_commission_generated: 'comisión total generada',
  total_deposits: 'depósitos totales',
  total_withdrawals: 'retiradas totales',
  date_joined: 'fecha en que se unió',
  more: 'más',
  banners: 'banners',
  partner_marketing_material: 'Socio - Material de marketing',
  partner_overview: 'Socio - Descripción general',
  partner_payout: 'Socio - Pago',
  partner_payout_request_message: 'Su solicitud ha sido registrada',
  select_your_default_payment_option: 'Seleccione su opción de pago predeterminada:',
  beneficiary_name_on_account: 'Beneficiario (nombre en la cuenta)',
  bank_address: 'Dirección del banco',
  sorty_code_if_applicable: 'Código de clasificación (si corresponde)',
  your_provider_email: 'Su correo electrónico de {provider}',
  select: 'seleccionar',
  next: 'siguiente',
  please_confirm_your_bank_details: 'Confirme sus datos bancarios:',
  bank: 'banco',
  sub_partners: 'Socios secundarios',
  state: 'estado',
  date: 'fecha',
  internal_transfer_instructions:
    'Puede transferir fondos entre sus cuentas de operaciones.<br>Introduzca el importe de la transferencia deseada y seleccione las cuentas de origen y destino.<br>Las transferencias internas se procesan inmediatamente.',
  transfer_complete: 'transferencia completa',
  transfer_from: 'transferencia desde',
  internal_transfer_processed_successfully: 'La transferencia interna se procesó correctamente.',
  external_transfer_processed_successfully: 'La transferencia externa se procesó correctamente.',
  select_account: 'seleccionar cuenta',
  to: 'a',
  warning_currency_conversion_will_take_place: 'advertencia: se llevará a cabo la conversión de moneda',
  transfer: 'transferencia',
  account: 'cuenta',
  currency: 'divisa',
  balance: 'saldo ',
  equity: 'capital',
  download: 'descargar',
  launch: 'lanzar',
  email: 'correo electrónico',
  password: 'contraseña',
  forgot: 'olvidé',
  forgot_password: 'olvidé la contraseña',
  risk_warning_footer:
    'Advertencia de riesgo: Las operaciones con productos apalancados como Forex y CFD pueden no ser adecuadas para todos los inversores, ya que conllevan cierto riesgo para su capital. Antes de operar, asegúrese de comprender plenamente los riesgos, teniendo en cuenta sus objetivos de inversión y su nivel de experiencia y, si es necesario, busque asesoramiento independiente. Por favor, lea de forma completa los/las <a href = "{riskURL}">Risk Disclosure</a>.',
  error_contact_support: 'Se ha producido un error; póngase en contacto con el servicio de asistencia.',
  type: 'tipo',
  funded: 'financiado',
  username: 'nombre de usuario',
  company_name: 'nombre de la empresa',
  website: 'sitio web',
  first_name: 'nombre',
  last_name: 'apellido',
  date_of_birth: 'fecha de nacimiento',
  gender: 'género',
  phone: 'teléfono',
  dial_code: 'código de marcado',
  country: 'país',
  address: 'dirección',
  year_moved_to_address: 'año en el que se mudó a la dirección',
  post_code: 'código postal',
  selected_currency: 'divisa seleccionada',
  january: 'enero',
  february: 'febrero',
  march: 'marzo',
  april: 'abril',
  may: 'mayo',
  june: 'junio',
  july: 'julio',
  august: 'agosto',
  september: 'septiembre',
  october: 'octubre',
  november: 'noviembre',
  december: 'diciembre',
  already_have_an_account: 'ya tengo una cuenta',
  invalid_request_login_required: 'solicitud no válida; primero debe iniciar sesión.',
  register_accounttype_account: 'registrar una cuenta {accountType}',
  client_type: 'tipo de cliente',
  individual: 'individual',
  company: 'empresa',
  company_information: 'información de la empresa',
  company_website: 'sitio web de la empresa',
  complete_live_registration: 'complete el registro en directo',
  title: 'título',
  confirm_password: 'confirme la contraseña',
  select_country: 'seleccione país',
  phone_number: 'numero teléfono',
  choose_trading_platform: 'elegir plataforma de operaciones',
  select_option: 'seleccionar opción',
  day: 'día',
  month: 'mes',
  year: 'año',
  company_registration_information: 'información de registro de la empresa',
  date_of_registration: 'fecha de registro',
  select_nationality: 'seleccionar nacionalidad',
  nationality: 'nacionalidad',
  select_gender: 'seleccionar género',
  male: 'masculino',
  female: 'femenino',
  address_line: 'línea de dirección',
  city_town: 'ciudad/población',
  state_province: 'estado/provincia',
  select_year: 'seleccionar año',
  year_moved_to_current_address: 'año en el que se mudó a la dirección actual',
  company_shareholders_directors: 'accionistas y directores de la empresa',
  number_of_shareholders: 'número de accionistas',
  number_of_directors: 'número de directores',
  shareholder: 'accionista',
  financial_information: 'información financiera',
  total_estimated_net_worth: '¿patrimonio neto total estimado (€)?',
  less_than_amount: 'menos de {amount}',
  over_amount: 'más de {amount}',
  total_estimated_annual_income: '¿ingresos anuales totales estimados (€)?',
  employment_information: 'información laboral',
  employment_status: 'situación laboral',
  employed: 'empleado',
  self_employed: 'autónomo',
  retired: 'jubilado',
  student: 'estudiante',
  unemployed: 'desempleado',
  source_of_income: 'fuente de ingresos',
  employment: 'empleo',
  inheritance: 'herencia',
  investment: 'inversión',
  trading_experience: 'experiencia en operaciones',
  forex_cfds_and_other_instruments: 'forex, cfd y otros instrumentos',
  yes: 'sí',
  no: 'no',
  lose_capital_risk:
    'Los productos derivados son adecuados como parte de mis objetivos de inversión y mi actitud hacia el riesgo, y puedo evaluar el riesgo que implica operar con ellos, incluida la posibilidad de que pueda perder todo mi capital',
  prev_pro_qualifications: 'Cuento con cualificaciones profesionales previas o experiencia laboral en el sector de servicios financieros',
  account_type: 'tipo de cuenta',
  choose_currency: 'elegir divisa',
  tos_with_link: 'He leído, comprendido y acepto los términos y condiciones y la divulgación de advertencias de riesgos <a target="_blank" href="{URL}">aquí</a>',
  registration_successful: 'registro correcto',
  reset_password_invalid_link: 'Su enlace de restablecimiento no es válido. Vuelva a intentarlo o póngase en contacto con el servicio de asistencia.',
  reset_account_password: 'restablecer la contraseña de la cuenta',
  choose_your_new_password: 'elija su nueva contraseña',
  reset_password: 'restablecer contraseña',
  file_upload_failed_filename: 'la carga solicitada para el archivo {filepath} ha fallado.',
  withdrawal_request_success_message: 'su solicitud de retirada se ha realizado correctamente',
  withdraw: 'retirada',
  please_fill_the_following: 'rellene lo siguiente',
  cancel: 'cancelar',
  withdraw_select_ta_p: 'Seleccione la cuenta de operaciones para la que desea realizar retiradas:',
  free_margin_change_warning: 'Tenga en cuenta que la retirada debe hacerse con el mismo método con el que depositó en su cuenta.',
  you_need_an_ib_account_to_visit_this_page: 'Necesita una cuenta de IB para visitar esta página',
  no_permission_to_to_visit_this_page: 'No tiene permiso para visitar esta página',
  you_became_a_partner_successfully: '¡Se ha convertido en socio de EUROTRADER con éxito!',
  note_wallet_currency_conversion_partner:
    'Tenga en cuenta que al convertirse en socio, la divisa de su cartera se cambiará a USD y que los fondos actuales se convertirán a USD al tipo de cambio actual.',
  upgraded_to_a_live_account_successfully: '¡Ha mejorado a una cuenta real correctamente! ',
  passwords_dont_match: 'Las contraseñas no coinciden',
  password_rules: 'Al menos 1 mayúscula, 1 minúscula y 1 número (de 6 a 16 caracteres como máximo)',
  please_fill: 'rellene',
  partner_verify_first_notice: 'Para convertirse en socio, primero debe verificar su cuenta. Cargue sus documentos <a href="upload-documents">aquí</a>',
  only_currency_format_allowed: 'solo se permite el formato de moneda',
  please_enter_your_account_id: 'Introduzca el ID de su cuenta',
  min_deposit_with_bankwire_is_amount: 'El depósito mín. con transferencia bancaria es de {amount}',
  please_select_different_tas: 'Seleccione diferentes cuentas de operaciones',
  you_need_to_accept_our_tos: 'Debe aceptar nuestras condiciones.',
  phone_is_required: 'el teléfono es obligatorio',
  invalid_phone_number: 'número de teléfono no válido',
  you_must_be_over_18: 'Debe ser mayor de 18 años.',
  year_is_required: 'El año es obligatorio',
  leave_page_question: '¿Salir de la página?',
  registration_exit_notice: 'Aún no ha finalizado su registro. ¿Quiere irse sin terminar?',
  internal_server_error_support: 'Error interno del servidor. Contacte con el servicio de asistencia técnica',
  please_fill_all_fields: 'Rellene todos los campos',
  no_logs_found_for_this_client: 'No se han encontrado registros para este cliente',
  no_accounts_send: 'No se han enviado cuentas',
  internal_server_error_try_again: 'Error interno del servidor. Inténtelo de nuevo más tarde',
  insufficient_balance: 'Saldo insuficiente',
  currency_conversion_connection_error: 'No hay respuesta del servidor de conversión de divisas. Inténtelo de nuevo o póngase en contacto con el servicio de asistencia técnica.',
  currency_conversion_error: 'Error de conversión de moneda. Inténtelo de nuevo o póngase en contacto con el servicio de asistencia técnica.',
  invalid_accounts: 'Cuentas no válidas',
  withdrawal_unsuccessful_equity_message: 'Retirada fallida; no hay suficiente capital en la cuenta de operaciones {TAID}',
  withdrawal_failed_free_margin: 'La retirada falló. Compruebe su margen libre.',
  pamm_copy_server_field_message: 'copie y pegue la dirección IP en el campo Servidor de su servidor MT4',
  invalid_request: 'solicitud no válida',
  missing_shareholders_directors: 'Faltan los accionistas/directores',
  missing: 'Falta',
  invalid_request_passwords_do_not_match: 'Solicitud no válida. Las contraseñas no coinciden',
  email_exists_message: 'El correo electrónico ya existe. Inténtelo con otra dirección de correo electrónico.',
  your_payment_method_has_already_been_set: 'Su método de pago ya se ha establecido. Contacto con el servicio de asistencia técnica',
  payment_method_is_required_message: 'El método de pago es obligatorio. Inténtelo de nuevo o póngase en contacto con el servicio de asistencia técnica',
  couldnt_find_your_account: 'No se pudo encontrar su cuenta',
  ta_limit_error_message: 'Su cuenta ha alcanzado el límite de cuentas de operaciones ({limit}) para {platform}.',
  error: 'error',
  account_created_successfully: 'cuenta creada con éxito',
  invalid_leverage: 'apalancamiento no válido',
  insufficient_data_provided: 'datos insuficientes',
  insufficient_data_provided_missing_field: 'Datos insuficientes. Falta el/la {field}.',
  invalid_amount: 'importe no válido',
  account_taid_doesnt_exist: 'La cuenta {TAID} no existe',
  withdrawal_unsuccessful_equity_taid: 'Retirada fallida; no hay suficiente capital en la cuenta de operaciones {TAID}',
  withdrawal_unsuccessful_free_margin_taid: 'Retirada fallida; no hay suficiente margen libre en la cuenta de operaciones {TAID}',
  internal_server_error: 'error interno del servidor',
  deposit_failed_support: 'El depósito no se ha realizado correctamente. Póngase en contacto con el servicio de asistencia técnica.',
  upload_documents_instructions: 'Envíenos los siguientes documentos.<br>Los archivos deben estar en formato PDF, JPG o PNG y no deben superar los 5 MB.',
  total_earned: 'total ganado',
  total_paid: 'total pagado',
  total_clients: 'total de clientes',
  total_sub_ibs: 'sub ibs totales',
  see_trading_accounts: 'ver cuentas de operaciones',
  see_trades: 'ver operaciones',
  welcome_title_live: '¡Gracias por abrir su cuenta con EUROTRADER!',
  welcome_title_demo: '¡Gracias por abrir su cuenta de prueba con EUROTRADER!',
  welcome_title_ib: '¡Gracias por abrir su cuenta de socio con EUROTRADER!',
  welcome_text_live:
    '<p>Para obtener fondos, aprobar su cuenta y estar listo para operar, debe completar los siguientes pasos:</p><ul><li>Inicie sesión en el portal del cliente de Eurotrader</li><li>Cargue sus documentos</li><li>Deposite fondos en su cuenta</li><li>Empiece a operar</li></ul><p>Si necesita ayuda, nuestro amable equipo de atención al cliente está disponible las 24 horas del día, los 5 días de la semana. Para ponerse en contacto con ellos, haga clic <a href="{contactURL}" target="_blank">aquí</a></p>',
  welcome_text_demo:
    '<p>Para obtener fondos, aprobarse y estar listo para operar, debe completar los siguientes pasos:</p><ul><li>Descargue la plataforma MT4</li><li>Ponga a prueba sus habilidades para operar y nuestras velocidades de ejecución</li><li>Inicie sesión en su portal del cliente y mejore a una cuenta real</li><li>Cargue sus documentos y añada fondos a su cuenta</li><li>Opere en el mercado financiero más grande del mundo</li></ul><p>Si necesita ayuda, nuestro amable equipo de atención al cliente está disponible las 24 horas del día, los 5 días de la semana. Para ponerse en contacto con ellos, haga clic <a href="{contactURL}" target="_blank">aquí</a></p>',
  welcome_text_ib:
    '<p>Para que su cuenta de socio sea aprobada y esté lista para recibir su URL de recomendación, debe completar los siguientes pasos:</p><ul><li>Inicie sesión en su portal del cliente</li><li>Cargue sus documentos</li><li>Reciba su URL de seguimiento en las secciones "descripción general" y "herramientas de marketing"</li><li>Recomiende a sus clientes y reciba comisiones</li></ul><p>Si necesita ayuda, nuestro amable equipo de atención al cliente está disponible las 24 horas del día, los 5 días de la semana. Para ponerse en contacto con ellos, haga clic <a href="{contactURL}" target="_blank">aquí</a></p>',
  bankwire_passports_notice: 'IMPORTANTE: Se requieren pasaportes como prueba de identidad para realizar una transferencia bancaria.',
  tracking_links: 'enlaces de seguimiento',
  proof_of_residence: 'prueba de residencia',
  login_to_your_account: 'inicie sesión en<br>su cuenta',
  register: 'registrarse',
  open_demo_account: 'abrir una cuenta de prueba',
  create_partner_account: 'crear cuenta de socio',
  page_title_partner: 'Conviértase en socio | Eurotrader',
  ib_payout_msg_monthly_payment: 'Los pagos se realizan cada dos meses mediante el método que elija. Los pagos se realizarán el día 15 y el 1 de cada mes.',
  payout_selection_complete: 'Se ha seleccionado el método de pago.',
  home: 'casa',
  about: 'acerca de',
  account_types: 'tipos de cuenta',
  spreads: 'spreads',
  funding: 'financiación',
  education: 'educación',
  contact: 'contacto',
  forex_broker: 'bróker de forex',
  services_provided_by: 'Servicios financieros proporcionados por Eurotrade Global Ltd',
  footer_certificate_eurotrader:
    '<a href="https://eservices.cipc.co.za/Search.aspx" style="color: #e04ef8; text-decoration: underline" target="_blank">Eurotrade SA (Pty) Ltd</a> ("Eurotrader") es una filial de Eurotrade RGB Holdings Ltd (HE367109) y es un proveedor de servicios financieros autorizado, con licencia y regulado por la Autoridad de Conducta del Sector Financiero (FSCA) en Sudáfrica con número de licencia FSP <a href="https://www.fsca.co.za/Fais/Search_FSP.htm" style="color: #e04ef8; text-decoration: underline" target="_blank">44351</a> con domicilio social en 74 Walmer street, Sydenham, Johannesburg, 2192, South Africa.<br /><br /><!-- Eurotrader" es una marca registrada de Eurotrade Investments RGB Ltd, una empresa de inversión chipriota (CIF) con el número de registro HE317893, autorizada y regulada por la Comisión de Valores y Bolsa de Chipre (CySEC) con la licencia 279/15, con domicilio social en 70, Kyrillou Loukareos Street, Kakos Premier Tower, 1st Floor, 4156 Limassol, Chipre. El procesamiento de la tarjeta será llevado a cabo por Eurotrade Investments RGB Ltd.<br /><br /> -->Eurotrader does not provide services to residents of certain jurisdictions including the USA, Iran, Canada, the Democratic Republic of Korea, Belgium, Japan, and is not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.<br /><br />Eurotrade SA (PTY) Ltd does not actively target EU clients.',
  footer_risk_warning:
    'Las operaciones con productos apalancados como Forex y CFD podrían no ser adecuadas para todos los inversores, ya que conllevan cierto riesgo para su capital. Antes de operar, asegúrese de comprender plenamente los riesgos que implica, teniendo en cuenta sus objetivos de inversión y su nivel de experiencia y, si es necesario, busque asesoramiento independiente.<a href="https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf" style="color: #e04ef8; text-decoration: underline" target="_blank">Lea la Divulgación de riesgos completa.</a>',
  open_live_account: 'abrir una cuenta real',
  not_registered_with_question: '¿No está registrado en Eurotrader?',
  forgot_password_q: '¿olvidó su contraseña?',
  pending_deposit_success: 'Operación realizada con éxito; su depósito está ahora pendiente de aprobación',
  your_card_will_be_charged_cny: 'Su tarjeta recibirá un cargo de <b>{amount}</b> CNY',
  currency_conversion_info: 'Información de conversión de moneda',
  min_deposit_is_amount: 'El depósito mín. es de {amount}',
  min_transfer_is_amount: 'La transferencia mín. es de {amount}',
  local_depositor: 'Depositante local',
  converted_amount: 'importe convertido',
  from_currency: 'de la divisa',
  to_currency: 'a la divisa',
  reference_id: 'id de referencia',
  from_account: 'de la cuenta',
  to_account: 'a la cuenta',
  from_date: 'fecha desde',
  to_date: 'fecha hasta',
  target_account_id: 'iD de cuenta de destino',
  wallet: 'cartera',
  received: 'recibido',
  send: 'enviar',
  sender_not_a_transfer_account: 'el remitente no es un depositante local',
  withdrawal_failed_support: 'La retirada no se ha realizado correctamente; póngase en contacto con el servicio de asistencia técnica.',
  clear: 'borrar',
  transfer_completed_successfully: 'transferencia completada con éxito',
  receive: 'recibir',
  view_trades: 'ver operaciones',
  your_provider_account_number: 'Su número de cuenta de {provider}',
  your_bitcoin_address: 'Su dirección de Bitcoin',
  your_crypto_address: 'Su dirección de {crypto}',
  destination_tag: 'Etiqueta de destino',
  change_trading_account_password: 'cambiar la contraseña de la cuenta de operaciones',
  your_card_will_be_charged_thb: 'Su tarjeta recibirá un cargo de <b>{amount}</b> THB',
  dashboard: 'panel de control',
  sent: 'enviado',
  client_state_approved: 'aprobado',
  client_state_pending: 'pendiente',
  client_state_incomplete: 'incompleto',
  open_trades: 'operaciones abiertas',
  trade_history: 'historial de operaciones',
  search_trades: 'buscar operaciones',
  trade_no: 'n.º de operación',
  symbol: 'símbolo',
  open_price: 'precio de apertura',
  close_price: 'precio de cierre',
  datetime: 'fecha y hora',
  my_bonuses: 'mis bonificaciones',
  bonus: 'bonificación',
  conversion_progress: 'progreso de conversión',
  front_of_id: 'Anverso del documento de identidad',
  back_of_id: 'Reverso del documento de identidad',
  include_account_in_bonus_program: 'Me gustaría unirme al Programa de operaciones financiadas al 111 %.',
  invest_under_master_account: 'invertir con una cuenta maestra',
  i_accept_the_terms_of_service: 'acepto los términos del servicio',
  pamm_master_locks_withdrawals: '[¡esta maestra de pamm restringe las retiradas durante las operaciones abiertas!]',
  open_p_l: 'abrir p y g',
  p_l: 'P y g',
  gains_prc: '% de ganancias',
  max_drawdown: 'máx. pérdida',
  bonus_tos_with_link: 'He leído y comprendido las <a target="_blank" href="{URL}">condiciones del Programa de operaciones financiadas al 111 %</a>.',
  i_am_over_18: 'Declaro que soy mayor de 18 (dieciocho) años para abrir esta cuenta.',
  all_time: 'todo el tiempo',
  last_month: 'el mes pasado',
  last_week: 'la semana pasada',
  last_3_days: 'últimos 3 días',
  monthly_avg: 'promedio mensual',
  profit: 'ganancia',
  create_and_attach: 'crear y adjuntar',
  attach: 'adjuntar',
  create_and_attach_new_pamm_account: 'crear y adjuntar una nueva cuenta de pamm',
  select_a_pamm_account_to_attach: 'seleccione una cuenta de pamm para adjuntar',
  enter_private_code: 'introducir código privado',
  private_code: 'código privado',
  investor_link: 'Enlace del inversor',
  i_accept_the_lpoa: 'acepto la lpoa',
  invest: 'invertir',
  view_graph: 'ver gráfico',
  name: 'nombre',
  search: 'buscar',
  partners: 'socios',
  reject_withdrawls_during_open_trades: 'rechazar retiradas durante operaciones abiertas',
  private_master_account: 'cuenta maestra privada',
  minimum_deposit: 'depósito mínimo',
  performance_fee: 'comisión de rentabilidad',
  display_name: 'nombre para mostrar',
  new_master_account: 'nueva cuenta maestra',
  pamm_statistics: 'estadísticas de pamm',
  pamm: 'pamm',
  volume_traded: 'volumen negociado',
  apply_date_range: 'aplicar rango de fechas',
  pamm_master_locks_deposits: '[¡esta maestra de pamm restringe las retiradas durante las operaciones abiertas!]',
  bitcoin: 'Bitcoin',
  register_live_account: 'registrar una cuenta real',
  register_partner_account: 'registrar una cuenta de socio',
  register_demo_account: 'registrar una cuenta de prueba',
  risk_disclosure: 'divulgación de riesgos',
  address_line_2: 'línea de dirección 2',
  skype_id: 'identificación de skype',
  password_rules_extended:
    'La contraseña debe contener al menos: 1 letra mayúscula, 1 letra minúscula, 1 número y un carácter especial. La contraseña debe tener entre 8 y 16 caracteres.',
  login_information: 'información de inicio de sesión',
  director: 'director',
  pmethod_visa_mastercard: 'VISA/MASTERCARD',
  pmethod_visa_mastercard_alternative: 'VISA/MASTERCARD.',
  pmethod_bitcoin: 'BITCOIN',
  pmethod_bankwire: 'Transferencia bancaria',
  pmethod_fasapay: 'Fasapay',
  pmethod_ideal: 'ideal',
  pmethod_instant_bank_transfer: 'Transferencia bancaria instantánea',
  pmethod_jeton: 'Jeton',
  pmethod_jeton_wallet: 'Jeton Wallet',
  pmethod_my_pay: 'MyPay',
  pmethod_neteller: 'NETELLER',
  pmethod_vload: 'VLOAD',
  pmethod_paykasa: 'Paykasa',
  pmethod_skrill: 'Skrill',
  pmethod_sofort: 'Sofort',
  pmethod_koalapay: 'KoalaPay',
  pmethod_cup: 'COPA',
  pmethod_lydiax: 'Criptomonedas',
  pmethod_safecharge: 'SafeCharge',
  pmethod_trustly: 'Trustly - Transferencia bancaria',
  pmethod_powercash: 'PowerCash',
  pmethod_astropay: 'AstroPay',
  field_min_currency_value: 'El campo {field} debe ser {min} o más.',
  method_deposit: 'depósito mediante {method}',
  method_deposit_status: 'estado del depósito mediante {method}',
  quick_menu: 'menú rápido',
  details: 'detalles',
  date_from: 'fecha desde',
  date_to: 'fecha hasta',
  from: 'desde',
  forgot_password_form_instruction:
    'Envíe la dirección de correo electrónico de su cuenta a continuación. A continuación, recibirá un correo electrónico con un enlace para restablecer su contraseña.',
  forgot_password_submit_success_message:
    'Se ha enviado un enlace para restablecer la contraseña a su correo electrónico. Vaya a su correo electrónico ({email}) y siga el enlace para cambiar su contraseña.',
  password_reset_successfully: 'Su contraseña se ha restablecido correctamente',
  password_too_week_or_mismatch: 'La contraseña es demasiado débil o las entradas de las contraseñas no coinciden.',
  withdrawals_credit_card_remaining_amount_message: 'Para retirar a través de otros métodos, primero debe retirar {amount} a su tarjeta de crédito.',
  withdrawals_credit_card_refund_policy_message: 'Los proveedores de tarjetas de crédito solo le permiten retirar el importe total que depositó en su tarjeta.',
  withdrawals_amount_withdrawable_message:
    'Se puede retirar un total de {amount} a su tarjeta, y cualquier importe que supere ese se puede retirar mediante uno de nuestros otros métodos.',
  country_blocked_for_this_method: 'Este método está bloqueado en su país',
  copied_text_successfully: '{text} copiado correctamente',
  choose_wallet_currency: 'elegir la divisa de la cartera',
  pamm_master_account_created_successfully: 'Cuenta maestra PAMM creada correctamente',
  or_account_no_for_uk: 'o número de cuenta (para clientes del Reino Unido)',
  issue_date: 'Fecha de emisión',
  expiry_date: 'Fecha de caducidad',
  full_copy_of_the_document: 'Copia completa del documento con las 4 esquinas',
  recent_date: 'Fecha reciente (no mayor de 3 meses)',
  your_physical_address: 'Su dirección física, que coincida con la dirección que utilizó al registrarse para la cuenta',
  must_be_a_utility_bill:
    'Debe ser una factura de servicios públicos (electricidad, agua, teléfono, gas/energía, impuestos municipales/facturas de saneamiento) o un extracto bancario',
  for_further_info_attach: '**Si dispone de otro tipo de documentación, adjúntela a un correo electrónico y envíela a backoffice@eurotrader.com',
  banners_ad_blocker_notice: 'Si tiene problemas para ver los banners a continuación, desactive su bloqueador de anuncios',
  transfer_out: 'transferencia (fuera)',
  transfer_in: 'transferencia (dentro)',
  done: 'hecho',
  not_required: 'no requerido',
  wallet_balance: 'saldo de la cartera:',
  must_agree_terms: 'Debe aceptar nuestras condiciones para crear una cuenta',
  select_payment_method: 'seleccionar forma de pago',
  islamic_account: 'Cuenta islámica',
  islamic_documents_instructions: 'Prueba de fe/religión de la mezquita',
  card_number: 'número de tarjeta',
  expiry: 'Caducidad',
  redeem: 'canjear',
  must_be_multiple_of_10: 'El valor debe ser un múltiplo de 10',
  select_starting_balance: 'Seleccionar saldo inicial',
  business_name: 'nombre de la empresa',
  business_bank_wire_instructions: 'instrucciones de transferencia bancaria para empresas',
  error_request_failed: 'Error: Solicitud fallida',
  error_no_user_with_this_email: 'Error: No se ha encontrado una cuenta con esta dirección de correo electrónico',
  error_too_many_password_reset_requests: 'Error: Demasiados restablecimientos de contraseña',
  error_expired_or_invalid_request: 'Error: Solicitud no válida o caducada',
  error_insufficient_wallet_balance: 'Error: Saldo insuficiente en la cartera',
  error_insufficient_balance_or_equity: 'Error: Saldo o capital insuficiente',
  error_pamm_master_deposit: 'No se puede depositar en una cuenta maestra PAMM',
  error_pamm_master_withdrawal: 'No se puede retirar dinero de una cuenta maestra PAMM',
  error_pamm_master_locked_deposits: 'Rechazado: La maestra pamm de la cuenta en la que se deposita el dinero rechaza los depósitos durante las operaciones abiertas.',
  error_pamm_master_locked_withdrawals: 'Rechazado: La maestra pamm de la cuenta de la que se retira el dinero rechaza las retiradas durante las operaciones abiertas.',
  error_pamm_master_minimum_deposit: 'Rechazado: No se ha cumplido el requisito de depósito mínimo de la maestra pamm.',
  error_live_account_already: 'Su cuenta ya es una cuenta real',
  error_min_balance_required_is: 'El saldo mínimo requerido para la cuenta {TAAccountType} ({TAID}) es de {min} {currency}.',
  error_transfer_same_wallet: 'No se puede transferir de una cartera a otra.',
  error_transfer_same_trading_account: 'No se pueden realizar transferencias desde y hacia la misma cuenta de operaciones.',
  error_no_deposit_bonus_account_deposit_restricted: 'No se permiten depósitos en el tipo de cuenta Bonificación sin depósito.',
  error_no_deposit_bonus_base_amount_withdrawal: 'No se puede retirar la cantidad base de la Bonificación sin depósito.',
  error_no_deposit_bonus_withdraw_profit_requirement_not_met: 'No se puede retirar la Bonificación sin depósito si no se ha cumplido el requisito de ganancias.',
  error_no_deposit_bonus_withdraw_exceeds_max_withdrawable_profit: 'No se puede retirar más del beneficio máximo.',
  upgrade_required_for_live_ta: 'Se requiere una cuenta de cliente real y aprobada antes de poder abrir una cuenta de operaciones real.',
  error_wallet_currency_not_allowed_for_psp: 'La moneda de la cartera no está permitida para esta forma de pago.',
  error_invalid_or_expired_otp: 'Error: La OTP proporcionada no es válida o ha caducado.',
  error_max_confirmo_withdrawal_exceeded: 'Error: La solicitud de retirada de confirmación máxima es de 20 000 EUR/USD',
  error_max_anual_vload_withdrawal_exceeded: 'Error: Se ha superado la cantidad total máxima de solicitudes de retirada con VLoad',
  is_islamic_acc_message: 'Para crear una cuenta islámica, envíe una solicitud a backoffice@eurotrader.com para obtener más ayuda.',
  error_invalid_voucher: 'Error: El comprobante de VLoad no es válido o ya se ha canjeado',
  error_blocked_voucher: 'Error: El comprobante de VLoad está bloqueado por sospecha de fraude',
  error_voucher_data_mismatch: 'Error: El comprobante de VLoad se ha rechazado debido a la falta de coincidencia de los datos de la cuenta.',
  error_vload_voucher_below_minimum: 'Error: El comprobante de VLoad está por debajo del importe mínimo del depósito.',
  my_bank_has_a_swift_code: 'Mi banco tiene un código SWIFT',
  my_bank_does_not_have_a_swift_code: 'Mi banco no tiene un código SWIFT',
  bank_not_in_swift_network_instructions:
    'Si su banco no es miembro de la red SWIFT, proporciónenos los siguientes datos del banco corresponsal de su banco para recibir transferencias internacionales:',
  correspondent_bank_name: 'Nombre del banco corresponsal',
  correspondent_bank_city: 'Ciudad del banco corresponsal',
  correspondent_bank_swift: 'SWIFT del banco corresponsal',
  codigo: 'Codigo de Instituicao',
  identity_card: 'Cédula de Identidad',

  proof_of_cc: 'Comprobante de tarjeta de crédito/débito',
  front_of_cc: 'Anverso de la tarjeta',
  back_of_cc: 'Reverso de la tarjeta',
  proof_of_cc_instructions: 'Cargue su tarjeta de crédito o débito.',
  add_document: 'Añadir un documento (opcional)',
  cc_requirements_1: 'Copia completa del documento con las 4 esquinas.',
  cc_requirements_2:
    'Nombre de la tarjeta: la tarjeta que utilizará debe estar únicamente a su nombre. Todos los depósitos realizados con una tarjeta de un tercero se reembolsarán de inmediato.',
  cc_requirements_3: 'Fecha de caducidad: no menos de 3 meses.',
  cc_requirements_4:
    'Número de tarjeta: Los ocho números centrales de la tarjeta deben cubrirse con una hoja de papel. Solo los primeros cuatro y los últimos cuatro dígitos deben ser visibles.',
  cc_back_requirements_5: 'Código CVV: Utilice una hoja de papel para cubrir el código CVV.',
  cc_back_requirements_6: 'La tarjeta debe estar firmada.',
  click_to_add_another_document: 'Haga clic en la parte superior para añadir otro espacio para cargar documentos',
  add_up_to_4_extra_documents: 'Puede añadir hasta 4 documentos adicionales',
  add_up_to_10_extra_documents: 'Puede añadir hasta 10 documentos adicionales',
  complete_profile: 'Perfil completo',
  document_received: 'Hemos recibido su documento y nuestro equipo lo revisará.',
  please_check_the_box: 'Marque la casilla a continuación.',
  must_be_over_18: 'Debe ser mayor de 18 años para registrarse.',
  shareholders_must_be_over_18: 'Los accionistas deben ser mayores de 18 años para registrarse.',
  directors_must_be_over_18: 'Los directores deben ser mayores de 18 años para registrarse.',
  document_req_color: 'El documento debe estar en color',
  internal_error: 'Se ha producido un error interno.',
  please_enter_your_email: 'Introduzca su dirección de correo electrónico',
  do_you_want_to_transform_your_trading: '¿Quiere transformar sus operaciones?',
  reset_your_password_to_transfer_your_account: 'Restablezca su contraseña para transferir su cuenta.',
  reset_your_old_password: 'Restablecer su contraseña anterior',
  reset_password_desc:
    'Debido a una transferencia del sistema, debe actualizar su contraseña. Utilice el siguiente formulario para recibir un enlace para restablecer la contraseña.',
  eurotrader_login: 'Inicio de sesión de Eurotrader | Entre al centro de operaciones para subir de nivel de sus operaciones',
  your_email_is_verified: 'Su correo electrónico ya está verificado',
  click_here_to_login: 'Haga clic aquí para iniciar sesión',
  success_email_verified: '¡Éxito! Su correo electrónico ya está verificado',
  your_link_expired: 'Su enlace ha caducado',
  click_here_to_request_verification_email: 'Haga clic aquí para solicitar un nuevo correo electrónico de verificación.',
  a_new_verification_link_send: 'Se ha enviado un nuevo enlace de verificación a su dirección de correo electrónico.',
  invalid_request_please_check_your_link: 'Solicitud no válida Compruebe que el enlace sea correcto e inténtelo de nuevo.',
  invalid_verification_code: 'Código de verificación no válido',
  please_enter_amount: 'Introduzca el importe que desee depositar',
  bankwire_company_desc:
    '<p>Si usted es titular de una cuenta bancaria empresarial y desea utilizar la opción de transferencia bancaria registrando su cuenta empresarial con nosotros, envíenos la siguiente documentación por correo electrónico a backoffice@eurotrader.com</p><ul><li>Certificado de incorporación/empresa</li><li>Certificado de directores y secretario, si corresponde</li><li>Certificado de accionistas registrados/propietario único.</li><li>Memorando y artículos de asociación, también conocidos como artículos</li><li>Comprobante de identidad y dirección de todos los accionistas registrados, los usufructuarios y los directores.</li><li>Comprobante de domicilio relacionado con la empresa.</li></ul><p> Cualquier otro documento gubernamental/oficial que verifique la información solicitada anteriormente puede considerarse suficiente, en caso de que los documentos anteriores no se puedan proporcionar en dicho formato.</p>',
  bankwire_noncompany_desc: '<p>Esto cerrará la sesión de su cuenta personal y le redirigirá a nuestra página de registro de una cuenta de empresa.</p><p>¿Desea continuar?</p>',
  please_enter_card_detail_and_amount: 'INTRODUZCA LOS DATOS DE LA TARJETA Y EL IMPORTE QUE DESEE DEPOSITAR',
  important: 'IMPORTANTE',
  please_note_that_the_maximum_deposit_amount: 'Tenga en cuenta que el depósito máximo por día es de 1000 USD por tarjeta.',
  city: 'Ciudad',
  zip: 'Código zip/postal',
  please_note_that_after_three_unsuccessful_attempts:
    '*Tenga en cuenta que después de tres (3) intentos fallidos, la opción de pago VISA/MASTERCARD no estará disponible durante 24 horas.',
  epay_pro_desc:
    '<p>Estimado operador< br>< br>Lamentablemente, debido a ciertos problemas técnicos y restricciones, los depósitos con tarjeta de crédito a través de nuestro proveedor EPayPro se desactivarán temporalmente.<br><br>Visa y Mastercard se desactivarán a la medianoche a las 23:00 GMT del 04/04/2018. Tras la desactivación del proveedor de pagos, los depósitos se desactivarán temporalmente. Aunque nuestros proveedores de pagos no nos han proporcionado un intervalo de tiempo exacto para el tiempo de inactividad, estamos trabajando para implementar alternativas lo antes posible.<br><br>Estamos trabajando con nuestros proveedores para resolver los problemas actuales para que, en el futuro, las cuentas puedan reanudar el procesamiento de depósitos sin demora.<br><br>No dude en ponerse en contacto con nuestro equipo de asistencia técnica si tiene alguna pregunta.</p>',
  provider_redirect: 'Se le redirigirá a {proveedor}.',
  lydiax_note: 'El depósito mínimo es de 30 EUR/USD',
  lydiax_note1:
    'Si deposita menos de 30 EUR/USD en {crypto}, deberá enviar un correo electrónico a backoffice@eurotrader.com y solicitar un reembolso, proporcionando la dirección de {crypto} en la que desea recibir el reembolso.',
  lydiax_note2:
    'Introduzca la cantidad de {crypto} que desee depositar para ver una estimación de lo que obtendrá. Tenga en cuenta que los siguientes precios solo son válidos para cuando fueron solicitados y pueden cambiar en cualquier momento.',
  lydiax_note3: 'Crearemos una dirección de depósito para que la utilice.',
  lydiax_note4: 'Utilice la siguiente dirección para depositar {crypto}.',
  lydiax_note5: 'De ahora en adelante, esta dirección única se utilizará para sus depósitos con {crypto}.',
  lydiax_required_address: 'Si su cartera requiere la dirección y la etiqueta por separado, use:',
  tag: 'Etiqueta',
  lydiax_enter_deposit: 'INTRODUZCA LA CRIPTOMONEDA QUE DESEA DEPOSITAR',
  create_address: 'Crear dirección',
  please_note: 'Tenga en cuenta:',
  price_estimate: 'Precio estimado:',
  check_price: 'Consultar precio',
  vload_please_enter_voucher: 'INTRODUZCA SU NÚMERO PIN DEL COMPROBANTE DE VLOAD',
  vload_minimum: '<p>(El valor mínimo aceptable del cupón es <b>50</b> EUR o USD</p>',
  vload_vouchers: 'Necesito comprar comprobantes de VLoad',
  vload_note:
    'Realice un pago sin problemas con Visa/MasterCard, así como mediante transferencia bancaria.<br/>Obtenga más información sobre VLoad o compre un cupón de [EUR/USD] en vload.expert.',
  vload_note1: 'Para poder depositar con VLoad, primero debe aprobar su cuenta.',
  reason: 'Razón:',
  attempts: 'Intento {attempts} de {maxAttempts},',
  two_more_remaining: 'dos (2) más restantes',
  one_more_remaining: 'Solo queda UN (1) intento',
  please_contact_bank: '<br/>Póngase en contacto con el banco emisor de la tarjeta.<br/>Su tarjeta podría estar bloqueada para transacciones en el extranjero',
  edata_success_note:
    'Tenga en cuenta que podría cargarse una comisión adicional a su depósito, cargada por su banco emisor debido a la transacción internacional. Esta comisión será un cargo pequeño, pero variará de un banco a otro.<br><br>Esta transacción con tarjeta de crédito aparecerá en su estado de cuenta como "Tech Savvy Billing\', “Business Billing “ or “Business media Billing “.',
  you_can_try: 'puede intentarlo de nuevo',
  here: 'aquí',
  safe_charged_success_message: 'Nuestro equipo administrativo procesará su depósito en un plazo de 2 días hábiles.',
  thank_you: 'Gracias',
  your_deposit_successful: 'Su depósito se ha realizado correctamente',
  card_redirect: 'Se le redirigirá para que introduzca su tarjeta de crédito y sus datos personales.',
  bank_wire_withdrawal_note:
    'En caso de rechazo de una transferencia bancaria en nombre del banco receptor debido a datos bancarios incorrectos proporcionados por el cliente, los diversos gastos de administración de transferencias bancarias cobrados por los bancos involucrados se restarán del importe de retirada solicitado antes de acreditar la cartera del cliente.',
  please_enter_amount_withdraw: 'Introduzca el importe que desea retirar',
  bitcoin_note: 'Introduzca su dirección de Bitcoin y el importe que desea retirar',
  otp: 'Contraseña de un solo uso (OTP)',
  otp_send_email: 'Enviar OTP al correo electrónico',
  otp_additional_text: 'La OTP anterior es para la solicitud de retirada de Bitcoin actual que está realizando',
  otp_new_password: 'Se ha enviado una nueva contraseña de un solo uso (OTP) a su correo electrónico',
  otp_error: 'Error: no se pudo enviar la OTP',
  lydiax_withdrawal_note:
    'Introduzca la cantidad de {currency} que desea retirar para ver una estimación del {crypto} que obtendrá. Tenga en cuenta que los siguientes precios solo son válidos para cuando fueron solicitados y pueden cambiar en cualquier momento.',
  enter_currency_amount: 'Introduzca la cantidad de {currency} para verificar la estimación',
  lydiax_withdrawal_additional_note: 'La OTP anterior es para la solicitud de retirada de criptomonedas actual que está realizando',
  estimated: 'Estimado:',
  please_enter_your_crypto_address: 'Introduzca su dirección de {crypto} y el importe que desee retirar',
  select_cryptocurrency: 'Seleccionar criptomoneda',
  request_amount: 'Importe solicitado',
  amount_changes: 'Importe cobrado (incluye comisión)',
  operation_failed: '¡Operación fallida! Su solicitud no es válida',
  operation_failed_error: '¡Operación fallida! Se ha producido un error al procesar esta solicitud.',
  are_you_sure_create_master: '¿Está seguro de que desea crear una nueva cuenta y adjuntarla a esta maestra?',
  are_you_sure_attach_selected_account_to_master: '¿Está seguro de que desea adjuntar la cuenta seleccionada a esta maestra?',
  change_password_desc:
    '<strong>*</strong> Este cambio de contraseña no afectará a las contraseñas de su cuenta de operaciones. Visite la <strong>lista de cuentas</strong> para cambiar las contraseñas de su cuenta de operaciones, utilizando la opción de <strong>cambiar contraseña</strong> bajo el icono del engranaje.',
  client_assessment: 'EVALUACIÓN DEL CLIENTE',
  select_answer: 'Seleccione una respuesta...',
  declarations: 'DECLARACIONES',
  complele_profile_desc: '¿Está actualmente o ha estado involucrado en alguna actividad criminal o hay cargos penales pendientes en su contra ante un tribunal?',
  complete_profile_desc1:
    '¿Es usted o un familiar o colaborador cercano una persona políticamente expuesta? Las personas políticamente expuestas son las personas físicas a las que se han confiado funciones públicas destacadas en los últimos 12 meses; es decir, jefes de estado o de gobierno, políticos de alto nivel, funcionarios gubernamentales, judiciales o militares de alto nivel, altos ejecutivos de empresas de propiedad estatal, funcionarios de partidos políticos, etc.',
  are_you_us_citizen: '¿Es ciudadano estadounidense o residente en EE. UU. a efectos fiscales?',
  please_check_forms_errors: 'Revise los formularios para ver si hay errores.',
  profile_succesfully_completed: 'Perfil completado con éxito',
  please_select_country: 'Seleccione su país',
  set_country: 'Establecer país',
  empty_country_code: 'Código de país vacío; actualice la página e inténtelo de nuevo.',
  invalid_country_code: 'Código de país no válido; actualice la página e inténtelo de nuevo.',
  individual_company: '¿ES USTED UN INDIVIDUO O UNA EMPRESA?',
  prev: 'ANT',
  previous: 'ANTERIOR',
  complete: 'COMPLETO',
  please_select_an_option: 'Seleccione una opción para cada campo',
  swap: 'intercambiar',
  buy: 'comprar',
  sell: 'vender',
  sums: 'sumas',
  net_total: 'TOTAL NETO',
  deposit_page_desc:
    '<p class = "has-text-white is-size-5-desktop is-size-6-tablet is-size-6-mobile has-text-weight-bold" >Regístrese ahora y</p><p class = "is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold vload-promo-large-text">consiga <span class = "has-text-white has-text-weight-bold"> GRATIS un eVoucher de </span> <br/> 10 EUR/USD<br/></p>',
  deposit_page_desc1: 'El eVoucher de bonificación de 10 EUR/USD se activará',
  create_new_account: 'Crear una cuenta nueva',
  successfully_purchase_vload: 'comprar y canjear correctamente un eVoucher de VLoad de cualquier valor',
  upgrade_to_tier_2: 'Mejorar al nivel 2',
  register_now: 'REGÍSTRESE AHORA',
  back: 'VOLVER',
  my_card_desc: 'Aquí puede ver todas las tarjetas que ha utilizado para los pagos y su estado actual en nuestro sistema.',
  you_have_no_card: 'Aún no ha realizado depósitos con tarjeta.',
  card_no: 'Número de tarjeta',
  last_used: 'Utilizado por última vez',
  risk_warning: 'ADVERTENCIA DE RIESGO:',
  upload_documents_note: 'Si desea hacer un depósito con tarjeta, proporcione además los siguientes documentos para que sean revisados y aprobados.',
  please_select_your_country: 'Primero seleccione su país',
  add_another_document: 'Añadir otro documento',
  drop_files_upload: 'Suelte los archivos aquí para cargarlos',
  date_until: 'Fecha hasta',
  copy: 'Copiar',
  cvv: 'CVV',
  please_enter_crypto_amount: 'Introduzca la cantidad de {crypto}',
  vload_pin: 'Pin de VLoad',
  deposit_info:
    'El proveedor de pagos está experimentando problemas técnicos y los depósitos directos con Visa/Mastercard no están disponibles actualmente. Alternativamente, si desea depositar con Visa/Mastercard, puede usar la opción Vload',
  id: 'ID',
  pamm_modal_error: 'Entrada no válida para el nombre en pantalla. No lo deje en blanco ni introduzca más de 32 caracteres',
  pamm_modal_error1: 'Se ha introducido un valor no válido para el depósito mínimo. Introduzca un número entero positivo inferior a 1 000 000.',
  error_missing_required_field: 'Error; falta un campo obligatorio',
  page_not_found: 'PÁGINA NO ENCONTRADA',
  new_version_note: 'NUEVA VERSIÓN DETECTADA. HAGA CLIC AQUÍ PARA ACTUALIZAR',
  new_version_note1: 'Es posible que algunas funciones no estén disponibles hasta que actualice la página',
  records: 'Registros',
  gateway: 'puerta de entrada',
  train_up: 'ENTRENE MEJOR.',
  trade_up: 'OPERE MEJOR.',
  train_text_1: '¿Está listo para invertir en su futuro?',
  train_text_2: 'Comience con una cuenta de prueba sin riesgos y acceda a los recursos de aprendizaje de la Academia de Eurotrader.',
  train_list_item_1: 'Practique las operaciones en un entorno simulado.',
  train_list_item_2: 'Obtenga acceso a los mejores recursos de aprendizaje.',
  train_list_item_3: 'Forme parte de la comunidad de Eurotrader.',
  train_list_item_4: 'Recuerde: nada que perder, todo que ganar.',
  form_title_1: 'PRACTIQUE CON',
  form_title_2: 'SU',
  form_title_3: 'Cuenta de prueba',
  form_subtitle: 'Y obtenga acceso a recursos de aprendizaje',
  region: 'Región',
  wallet_currency: 'Moneda de la cartera',
  select_currency_label: 'Divisa de su cuenta de prueba',
  join: 'unirse',
  demo_account: 'Cuenta de prueba',
  page_title_demo: 'Abrir cuenta de prueba | Eurotrader',
  title_404: '¡CLARO QUE EL DINERO DA LA FELICIDAD!',
  text_line_1_404: '¿Qué? ¿No hay nadie aquí para ayudarle a invertir en su futuro?',
  text_line_2_404: 'Volvamos a la pantalla de inicio y demostremos a su dinero de qué pasta está hecho.',
  button_404: 'VOLVER',
  remember_me: 'Recordarme',
  risk_sentence: 'Para ver cómo utilizamos sus datos, consulte nuestra',
  video_courses: 'Cursos en vídeo',
  ebooks: 'Libros electrónicos',
  knowledge_and_experience: 'CONOCIMIENTO Y EXPERIENCIA',
  economic_profile: 'PERFIL ECONÓMICO',
  product_governance: 'GOBIERNO DE PRODUCTOS',
  select_an_answer: 'Seleccione una respuesta',
  declarations_q1: '¿Está actualmente o ha estado involucrado en alguna actividad criminal o hay cargos penales pendientes en su contra ante un tribunal?',
  declarations_q2:
    '¿Es usted o un familiar o colaborador cercano una persona políticamente expuesta? Las personas políticamente expuestas son las personas físicas a las que se han confiado funciones públicas destacadas en los últimos 12 meses; es decir, jefes de estado o de gobierno, políticos de alto nivel, funcionarios gubernamentales, judiciales o militares de alto nivel, altos ejecutivos de empresas de propiedad estatal, funcionarios de partidos políticos, etc.',
  declarations_q3: '¿Es ciudadano estadounidense o residente en EE. UU. a efectos fiscales?',
  ca_q1: '1. ¿Tiene experiencia en operaciones?',
  ca_q2: '2. ¿Durante cuánto tiempo ha invertido u operado en los mercados financieros?',
  ca_q3: '3. ¿Cuántas transacciones ha realizado en los últimos dos años?<br>&nbsp;&nbsp; a. Renta variable y renta fija (acciones y bonos)',
  ca_q4: '&nbsp;&nbsp; b. Forex',
  ca_q5: '&nbsp;&nbsp; c. CFD (contratos por diferencias)',
  ca_q6: '&nbsp;&nbsp; d. Otros productos derivados (warrants, opciones, derechos)',
  ca_q7: '4. ¿Cuáles fueron las cantidades medias (mensuales) que ha invertido en las siguientes categorías? <br> &nbsp;&nbsp; a. Renta variable y renta fija (acciones y bonos)',
  ca_q8: '&nbsp;&nbsp; b. Forex',
  ca_q9: '&nbsp;&nbsp; c. CFD (contratos por diferencias)',
  ca_q10: 'd. Otros productos derivados (warrants, opciones, derechos)',
  ca_q11: '5. ¿Qué tipo de servicios de inversión ha utilizado ya? (contiene varias respuestas)',
  ca_q12: '6. ¿Se aplica algo de lo siguiente? (contiene varias respuestas)',
  ca_q13:
    '7. La acción de Apple cotiza a un precio de venta de 204 dólares y un precio de compra de 206 dólares. Usted compra 100 acciones de Apple al precio mencionado anteriormente. ¿Cuál sería la ganancia o pérdida incurrida en su cuenta si el precio de la acción de Apple cambiara a un precio de venta de 190 dólares y un precio de compra de 192 dólares y usted cerrara su posición?',
  ca_q14:
    '8. La acción de Apple cotiza a un precio de venta de 204 dólares y un precio de compra de 206 dólares. Usted abre una operación de CFD larga (compra) por 100 contratos (cada contrato subraya 1 acción de Apple). El apalancamiento utilizado es de 1:5. ¿Cuál sería la ganancia o pérdida incurrida en su cuenta si el precio de la acción de Apple cambiara a un precio de venta de 190 dólares y un precio de compra de 192 dólares y usted cerrara su posición?',
  ca_q15: '9. Usando una orden de stop loss:',
  ca_q16: '10. El saldo de su cuenta es bajo ¿En cuál de estas ocasiones se le podría solicitar que añada fondos a su cuenta?',
  ca_q17:
    '11. El índice S&P 500 tiene un precio de compra de 2700 dólares. Decide abrir una operación de CFD larga (compra) de 2 contratos. El apalancamiento utilizado es 1:20. Usted establece una orden stop loss al precio de 2600 $ y una orden take profit al precio de 3000 $. Suponiendo que el saldo de su cuenta es suficiente y la orden no cambia hasta que se alcance el precio de venta de la stop loss o el precio de venta de la take profit, y no se incurra en cargos adicionales, ¿cuál sería la ganancia o pérdida en la que incurriría en su cuenta cuando la posición se cierre?',
  ca_q18: '1. ¿Cuáles son sus ingresos anuales totales?',
  ca_q19: '2. ¿Cuál es la fuente de sus ingresos?',
  ca_q20: '3. ¿Qué porcentaje de sus ingresos anuales se relaciona con obligaciones financieras?',
  ca_q21: '4. ¿Cuál es el valor estimado de sus activos?',
  ca_q22: '5. ¿Cuál es la estructura de sus activos?',
  ca_q23: '6. ¿Cuál es su valor neto estimado (activos totales - pasivos totales)?',
  ca_q24: '1. Seleccione una de las siguientes declaraciones:',
  ca_q25: '2. ¿Cuál de las siguientes afirmaciones es más adecuada para usted?',
  ca_q26: '3. ¿Cuál es más relevante para su estilo de inversión?',
  ca_q27: '4. En función de sus expectativas, ¿cuál es la fluctuación anual del valor de su cartera que está dispuesto a aceptar?',
  ca_q28: '5. ¿Cuál de las siguientes opciones se considerará la cartera más adecuada para usted?',
  ca_q29: '6. ¿Cuál es el horizonte temporal de sus objetivos de inversión?',
  ca_q30: '7. ¿Cuál es su objetivo de inversión?',
  ca_q31: '8. ¿Cuál es el nivel de liquidez de su cartera que está dispuesto a aceptar?',
  ca_q1_ao1: 'a) Sí, he operado con una cuenta real',
  ca_q1_ao2: 'b) Sí, he operado con una cuenta de prueba',
  ca_q1_ao3: 'c) No, pero he utilizado los servicios de inversión de gestión de carteras o asesoramiento en inversiones',
  ca_q1_ao4: 'd) No, pero tengo amplios conocimientos a través de mi formación (licenciatura, máster, etc.)',
  ca_q1_ao5: 'e) No',
  ca_q2_ao6: 'a) 0 - 6 meses',
  ca_q2_ao7: 'b) 6 - 12 meses',
  ca_q2_ao8: 'c) 1 - 2 años',
  ca_q2_ao9: 'd) De 2 a 4 años',
  ca_q2_ao10: 'e) Más de 4 años',
  ca_q3_ao11: 'I. Nunca',
  ca_q3_ao12: 'II. Rara vez (menos de 50 veces)',
  ca_q3_ao13: 'III. A veces (50-100 veces)',
  ca_q3_ao14: 'IV. Con frecuencia (más de 101 operaciones)',
  ca_q4_ao15: 'I. Nunca',
  ca_q4_ao16: 'II. Rara vez (menos de 50 veces)',
  ca_q4_ao17: 'III. A veces (50-100 veces)',
  ca_q4_ao18: 'IV. Con frecuencia (más de 101 operaciones)',
  ca_q5_ao19: 'I. Nunca',
  ca_q5_ao20: 'II. Rara vez (menos de 50 veces)',
  ca_q5_ao21: 'III. A veces (50-100 veces)',
  ca_q5_ao22: 'IV. Con frecuencia (más de 101 operaciones)',
  ca_q6_ao23: 'I. Nunca',
  ca_q6_ao24: 'II. Rara vez (menos de 50 veces)',
  ca_q6_ao25: 'III. A veces (50-100 veces)',
  ca_q6_ao26: 'IV. Con frecuencia (más de 101 operaciones)',
  ca_q7_ao27: 'i. 0',
  ca_q7_ao28: 'ii. Menos de 500 €',
  ca_q7_ao29: 'iii. 501 € - 2000 €',
  ca_q7_ao30: 'iv. 2001 € - 5000 €',
  ca_q7_ao31: 'v. Más de 5001 €',
  ca_q8_ao32: 'i. 0',
  ca_q8_ao33: 'ii. Menos de 500 €',
  ca_q8_ao34: 'iii. 501 € - 2000 €',
  ca_q8_ao35: 'iv. 2001 € - 5000 €',
  ca_q8_ao36: 'v. Más de 5001 €',
  ca_q9_ao37: 'i. 0',
  ca_q9_ao38: 'ii. Menos de 500 €',
  ca_q9_ao39: 'iii. 501 € - 2000 €',
  ca_q9_ao40: 'iv. 2001 € - 5000 €',
  ca_q9_ao41: 'v. Más de 5001 €',
  ca_q10_ao42: 'i. 0',
  ca_q10_ao43: 'ii. Menos de 500 €',
  ca_q10_ao44: 'iii. 501 € - 2000 €',
  ca_q10_ao45: 'iv. 2001 € - 5000 €',
  ca_q10_ao46: 'v. Más de 5001 €',
  ca_q11_ao47: 'a. Recepción y transmisión o ejecución de órdenes (servicios de inversión que requieren decisiones independientes)',
  ca_q11_ao48: 'b. Asesoramiento de inversión',
  ca_q11_ao49: 'c. Gestión de carteras',
  ca_q11_ao50: 'd. Ninguna',
  ca_q12_ao51: 'a. Tengo experiencia profesional relevante',
  ca_q12_ao52: 'b. Superviso regularmente las noticias y los mercados',
  ca_q12_ao53: 'c. He asistido a un seminario o curso relacionado con mercados financieros/inversiones/operaciones en línea',
  ca_q12_ao54: 'd. Ninguna de las anteriores',
  ca_q13_ao55: 'a. - 1200 €',
  ca_q13_ao56: 'b. - 1400 €',
  ca_q13_ao57: 'c. - 1600 €',
  ca_q13_ao58: 'd. - 1800 €',
  ca_q14_ao59: 'a. - 6000 €',
  ca_q14_ao60: 'b. - 7000 €',
  ca_q14_ao61: 'c. - 8000 €',
  ca_q14_ao62: 'd. - 10 000 €',
  ca_q15_ao63: 'a. Le protege de sufrir pérdidas rápidas',
  ca_q15_ao64: 'b. Limita su exposición al riesgo',
  ca_q15_ao65: 'c. Garantiza que nunca pierda ninguna operación',
  ca_q15_ao66: 'd. Le protege del riesgo de utilizar el apalancamiento',
  ca_q16_ao67: 'a. Si el precio del subyacente en una posición abierta se mueve en su contra de modo que que su capital sea inferior a su margen mínimo de mantenimiento.',
  ca_q16_ao68: 'b. Si incurre en comisiones de transacción que pongan su cuenta en estado de déficit.',
  ca_q16_ao69: 'c. Si una posición de CFD abierta incurre en cargos nocturnos, su cuenta entra en déficit.',
  ca_q16_ao70: 'd. Todo lo anterior.',
  ca_q17_ao71: 'a. - 100 o 300 $',
  ca_q17_ao72: 'b. - 200 o 600 $',
  ca_q17_ao73: 'c. - 2000 o 6000 $',
  ca_q17_ao74: 'd. - 4000 o 12 000 $',
  ca_q18_ao75: 'a. Menos de 20 000 €',
  ca_q18_ao76: 'b. Entre 20 000 y 50 000 €',
  ca_q18_ao77: 'c. Entre 50 000 y 100 000 €',
  ca_q18_ao78: 'd. Más de 100 000 €',
  ca_q19_ao79: 'a. Salario/Pensión',
  ca_q19_ao80: 'b. Dividendos/Intereses/Cupones',
  ca_q19_ao81: 'c. Alquileres',
  ca_q19_ao82: 'd. Donaciones/Herencias',
  ca_q19_ao83: 'e. Otra fuente de ingresos',
  ca_q20_ao84: 'a. Menos del 25 %',
  ca_q20_ao85: 'b. Entre el 25 y el 50 %',
  ca_q20_ao86: 'c. Entre el 50 y el 75 %',
  ca_q20_ao87: 'd. Más del 75 %',
  ca_q21_ao88: 'a. Menos de 100 000 €',
  ca_q21_ao89: 'b. Entre 100 000 y 500 000 €',
  ca_q21_ao90: 'c. Entre 500 000 y 1 000 000 €',
  ca_q21_ao91: 'd. Más de 1 000 000 €',
  ca_q22_ao92: 'a. Principalmente en depósitos bancarios',
  ca_q22_ao93: 'b. Principalmente en el sector inmobiliario',
  ca_q22_ao94: 'c. Principalmente en instrumentos financieros',
  ca_q22_ao95: 'd. Asignados equitativamente en las tres opciones anteriores',
  ca_q22_ao96: 'e. Otros',
  ca_q23_ao97: 'a. Menos de 100 000 €',
  ca_q23_ao98: 'b. Entre 100 000 y 500 000 €',
  ca_q23_ao99: 'c. Entre 500 000 y 1 000 000 €',
  ca_q23_ao100: 'd. Más de 1 000 000 €',
  ca_q24_ao101: 'a. Solo asumo riesgos que puedan reducir el capital invertido en circunstancias extremas.',
  ca_q24_ao102: 'b. Puedo arriesgar una parte de mi capital invertido para obtener un rendimiento superior a la media.',
  ca_q24_ao103: 'c. Puedo arriesgar una parte o la totalidad de mi capital invertido con la esperanza de obtener mayores beneficios.',
  ca_q25_ao104: 'a. Lo más importante para mí es la seguridad de mi capital. Por lo tanto, para evitar pérdidas, estoy dispuesto a renunciar a mayores beneficios',
  ca_q25_ao105: 'b. Con el fin de obtener una rentabilidad superior a la media, acepto asumir mayores riesgos y estoy dispuesto a aceptar la ligera disminución de mi capital.',
  ca_q25_ao106: 'c. Para obtener altos rendimientos, estoy dispuesto a asumir altos riesgos, incluso si una parte o la totalidad de mi capital está en riesgo.',
  ca_q26_ao107: 'a. Preservación de capital',
  ca_q26_ao108: 'b. Crecimiento de ingresos',
  ca_q26_ao109: 'c. Especulación',
  ca_q26_ao110: 'd. Cobertura',
  ca_q27_ao111: 'a. ± 5 %',
  ca_q27_ao112: 'b. ± 10 %',
  ca_q27_ao113: 'c. ± 25 %',
  ca_q27_ao114: 'd. ± 50 %',
  ca_q28_ao115: 'a. La que producirá un rendimiento estable del 1-2 % en los próximos años.',
  ca_q28_ao116: 'b. La que producirá rendimientos entre el -2 y el +10 % en los próximos años.',
  ca_q28_ao117:
    'c. La que se espera produzca una rentabilidad de entre el -15 y el +30 % durante el próximo año y que, en condiciones extremas, podría llegar a producir una pérdida superior a la invertida.',
  ca_q29_ao118: 'a. Hasta 1 año',
  ca_q29_ao119: 'b. Entre 1 y 3 años',
  ca_q29_ao120: 'c. Entre 3 y 5 años',
  ca_q29_ao121: 'd. Más de 5 años',
  ca_q30_ao122: 'a. Gestión de liquidez a corto plazo para cubrir gastos imprevistos.',
  ca_q30_ao123: 'b. Ahorro a largo plazo.',
  ca_q30_ao124: 'c. Obtener grandes beneficios incluso a riesgo de perder el importe invertido',
  ca_q31_ao125: 'a. Menos del 25 %',
  ca_q31_ao126: 'b. Entre el 25 y el 50 %',
  ca_q31_ao127: 'c. Entre el 50 y el 75 %',
  ca_q31_ao128: 'd. Más del 75 %',
  passport_ple_different: 'En caso de que su país de residencia y el país de expedición de su documento de identidad sean diferentes, cargue su pasaporte.',
  live_account: 'Cuenta real',
  agree_terms_marketing: 'Acepto recibir actualizaciones de marketing de Eurotrader (vea la <a href="{PRIVACY_URL}" target="_blank">política de privacidad</a> ).',
  data_policy_text:
    'Sus datos están seguros con nosotros y puede darse de baja en cualquier momento. Al hacer clic a continuación, confirma que ha leído y aceptado las <a href="{TERMS_CONDITIONS_URL}" target="_blank">condiciones</a> y la <a href="{RISK_DISCLOSURE_URL}" target="_blank"> divulgación de riesgos,</a> y usted consiente que guardemos y tratemos su información personal.',
  live_tos_with_link: 'He leído, comprendido y acepto las los términos y condiciones y la divulgación de advertencias de riesgos <a href="{URL}" target="_blank">aquí</a>.',
  must_agree_marketing_terms: 'Marque la casilla de verificación para continuar con el siguiente paso',
  tick_checkboxes: 'Marque las casillas de verificación para continuar',
  partner_account: 'Cuenta de socio',
  privacy_policy: 'política de privacidad',
  client: 'cliente',
  commission_amount: 'monto de la comisión',
  tier_name: 'tier name',
  trades_completed: 'transacciones completadas',
  trade: 'operar',
  pamm_investor_selection_note:
    "* Tenga en cuenta que las 'cuentas de Investor' están diseñadas específicamente para usarse en conexión con una cuenta Master y no se pueden negociar manualmente. Póngase en contacto con el servicio de atención al cliente si desea obtener más información sobre las cuentas de inversores.",
  bitpace_network_warning_BTC: 'Esta dirección es sólo para depósitos en Bitcoin. No envíe desde ninguna cadena que no sea BTC o su depósito puede perderse',
  bitpace_network_warning_LTC: 'Esta dirección es sólo para depósitos en Litecoin. No envíe desde ninguna cadena que no sea LTC o su depósito podría perderse',
  bitpace_network_warning_XRP: 'Esta dirección es sólo para depósitos Ripple. No envíe desde ninguna cadena que no sea XRP o su depósito puede perderse',
  bitpace_network_warning_BCH: 'Esta dirección es sólo para depósitos en Bitcoin Cash. No envíe desde ninguna cadena que no sea BCH o su depósito puede perderse',
  bitpace_network_warning_USDT:
    'Utilice únicamente redes Ethereum (ERC20) o TRON (TRC20). Su depósito se perderá y será irrecuperable si no utiliza las redes especificadas. No envíe fondos a través de BSC, BEP20, BEP-2 u otras redes.',
  bitpace_network_warning_USDC:
    'Utilice únicamente redes Ethereum (ERC20) o TRON (TRC20). Su depósito se perderá y será irrecuperable si no utiliza las redes especificadas. No envíe fondos a través de BSC, BEP20, BEP-2 u otras redes.',
  bitpace_network_warning_TRX:
    'Utilice únicamente la red TRON (TRC20). Su depósito se perderá y será irrecuperable si no utiliza la red TRON. No envíe fondos a través de BSC, BEP20, BEP-2 u otras redes.',
  bitpace_network_warning_LINK:
    'Utilice únicamente la red Ethereum (ERC20). Su depósito se perderá y será irrecuperable si no utiliza la red Ethereum. No envíe fondos a través de BSC, BEP20, BEP-2, TRC u otras redes.',
  crypto_note_text:
    'Estimado cliente,<br><br>Estamos encantados de compartir que nuestro depósito y retiro de cripto se han actualizado con una selección de monedas para elegir, incluyendo Ethereum, Ripple, Litecoin y más. Muchas gracias por su paciencia y le pedimos disculpas por las molestias ocasionadas.<br><br><strong>Por favor, tenga en cuenta que debe hacer clic en "Crear dirección" y copiar la última dirección cada vez que desee realizar un ingreso.</strong>',
  crypto_visit_page: 'Visite siempre esta página para obtener la última dirección criptográfica antes de depositar.',
  pamm_statistics_text:
    'Las estadísticas PAMM están disponibles en nuestra Área de clientes PAMM. Si usted tiene una cuenta PAMM, por favor haga clic en el enlace de abajo para ser redirigido, y utilice las credenciales de su cuenta PAMM para iniciar sesión.',
  leverage: 'Apalancamiento',
  bitpace_network_warning_BTC_withdrawal:
    'Asegúrese de que la dirección del monedero introducida es correcta y está en BTC. Si introduce una dirección incorrecta, perderá sus fondos.',
  bitpace_network_warning_LTC_withdrawal:
    'Asegúrate de que la dirección del monedero introducida es correcta y está en LTC. Si introduce una dirección incorrecta, perderá sus fondos.',
  bitpace_network_warning_XRP_withdrawal:
    'Asegúrate de que la dirección del monedero introducida es correcta y está en XRP. Si introduce una dirección incorrecta, perderá sus fondos.',
  bitpace_network_warning_BCH_withdrawal:
    'Asegúrate de que la dirección del monedero introducida es correcta y está en BCH. Si introduce una dirección incorrecta, perderá sus fondos.',
  bitpace_network_warning_USDT_withdrawal:
    'Asegúrese de que la dirección del monedero introducida es correcta y está en redes ERC20 o TRC20 y en USDT. Si introduce una dirección incorrecta, perderá sus fondos.',
  bitpace_network_warning_USDC_withdrawal:
    'Asegúrese de que la dirección del monedero introducida es correcta y está en redes ERC20 o TRC20 y en USDC. Si introduce una dirección incorrecta, perderá sus fondos.',
  bitpace_network_warning_TRX_withdrawal:
    'Por favor, asegúrese de que la dirección del monedero introducida es correcta y está en la red TRC20 y en TRX. Si introduce una dirección incorrecta, perderá sus fondos.',
  bitpace_network_warning_LINK_withdrawal:
    'Por favor, asegúrese de que la dirección del monedero introducida es correcta y está en redes ERC20 o TRC20 y está en LINK. Si introduce una dirección incorrecta, perderá sus fondos.',
}



// WEBPACK FOOTER //
// ./src/locale/es.js